import { SignUp } from '@clerk/clerk-react';
import { Helmet } from 'react-helmet-async';
/**
 * Clerk-hosted sign-up flow. After email verification (magic link),
 * Clerk redirects to /onboarding/complete via fallbackRedirectUrl, where
 * the API user row is created via POST /v1/users/invitation/complete.
 *
 * Auth strategy (email + magic link) is configured in the Clerk Dashboard.
 * This component owns the placement and visual surround; Clerk owns the
 * UI and the auth mechanics.
 *
 * `path` + `routing="path"` lets Clerk handle its own sub-routes
 * (verification, factor-two) beneath /sign-up. The App router mounts
 * this page at /sign-up/* to delegate those sub-paths.
 *
 * Below the Clerk component sits a single-line consent notice linking
 * to the Terms and Privacy Notice on the marketing site. This creates
 * documented assent at the point of sign-up — the standard SaaS pattern.
 * Users don't have to read the linked pages; they just have to be told
 * about them before signing up. Section 1 of the Terms makes the
 * sign-up = agreement link explicit on the receiving side.
 *
 * Sign-in does NOT need the equivalent notice: returning users have
 * already accepted the terms at sign-up. Material changes to the terms
 * are communicated by email per section 8 of the Terms.
 */
export default function SignUpPage() {
  return (
    <>
      <Helmet>
        <title>Sign up · TownInsider</title>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <main
        id="main-content"
        className="container-narrow safe-top safe-bottom flex min-h-dvh items-center justify-center px-4 py-8"
      >
        <div className="flex flex-col items-center gap-6">
          <SignUp
            path="/sign-up"
            routing="path"
            signInUrl="/sign-in"
            fallbackRedirectUrl="/onboarding/complete"
          />
          <p className="max-w-sm text-center text-xs leading-relaxed text-moor-500">
            By signing up you agree to our{' '}
            <a
              href="https://towninsider.co.uk/terms"
              target="_blank"
              rel="noopener noreferrer"
              className="text-moor-700 underline underline-offset-2 hover:no-underline"
            >
              Terms
            </a>{' '}
            and{' '}
            <a
              href="https://towninsider.co.uk/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-moor-700 underline underline-offset-2 hover:no-underline"
            >
              Privacy Notice
            </a>
            .
          </p>
        </div>
      </main>
    </>
  );
}
